import { render, staticRenderFns } from "./mobile-banner.vue?vue&type=template&id=8b1fa292&scoped=true"
import script from "./mobile-banner.vue?vue&type=script&lang=js"
export * from "./mobile-banner.vue?vue&type=script&lang=js"
import style0 from "./mobile-banner.vue?vue&type=style&index=0&id=8b1fa292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1fa292",
  null
  
)

export default component.exports